import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import Navigation from './FaqNavigation';
import NavigationBottom from './FaqNavigationBottom';
import { useDict } from '../../../contexts/LanguageContext';
import { useEffect } from 'react';

const FaqContainer = (props) => {
    const {
        children,
        prevLink,
        prevTitle,
        nextLink,
        nextTitle,
        navigationActive,
    } = props;

    const dict = useDict();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Container className="documentation pt-3">
            <Row className="mb-3">
                <Col md={12}>
                    <h3 className="page-title">{dict.faqUserGuide}</h3>
                </Col>
            </Row>
            <Row className="documentation__main">
                <Col
                    md={12}
                    lg={3}
                    xl={3}
                    sm={12}
                    xs={12}
                    className="documentation__nav"
                >
                    <Navigation active={navigationActive} />
                </Col>
                <Col md={12} lg={9} xl={9} sm={12} xs={12}>
                    {children}
                    <NavigationBottom
                        prevLink={prevLink}
                        prevTitle={prevTitle}
                        nextLink={nextLink}
                        nextTitle={nextTitle}
                    />
                </Col>
            </Row>
        </Container>
    );
};

export default FaqContainer;
